export const SCRIPT_IDS = {
  STORE: 'store',
  MESSAGES: 'messages',
  GRIFFIN: 'griffin',
  NAVIGATION: 'navigation',
}

export const ALLOWED_IMAGE_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/tiff',
]

export const UNALLOWED_ENCODED_IMAGE_TYPES = [
  '52494646', // Webp
  '57454250', // Webp
]
export const USER_AGREEMENT_LINK_COUNTRIES = ['FI', 'JP', 'LI']

export const DEFAULT_LOCALE = {
  LANGUAGE: 'en',
  COUNTRY: 'US',
}

export const TEST_OPTIONS_HEADER = 'X-PP-Test-Options'

export const AMOUNT_TYPES = {
  any: 'any',
  at_least: 'at_least',
  exactly: 'exactly',
}

export const GRADIENT_COLORS = {
  blue: 'blue',
  purple: 'purple',
  fuchsia: 'fuchsia',
  red: 'red',
  teal: 'teal',
  gray: 'gray',
  green: 'green',
  sky: 'sky',
  pink: 'pink',
  orange: 'orange',
}

export const EDITABLE_FIELDS = [
  'title',
  'end_date',
  'description',
  'category',
  'goal',
  'gradient_color',
  'background_image',
  'background_image_filename',
  'background_pan',
  'amount_type',
  'share_contributions',
  'share_contributors',
  'share_progress',
  'amount',
  'pledge',
]

export const DEFAULT_GRADIENT_COLOR = 'teal'

export const DAYS_THRESHOLD = 28

export const COVER_IMAGE_MAX_TOTAL_SIZE = 1600
export const CROWDFUNDING_COVER_IMAGE_MAX_TOTAL_SIZE = 5000000

export const CROWDFUNDING_GOAL_AMOUNT = {
  AU: {
    MAX_AMOUNT: 25000,
    MIN_AMOUNT: 1,
    currency: 'AUD',
  },
  CA: {
    MAX_AMOUNT: 25000,
    MIN_AMOUNT: 1,
    currency: 'CAD',
  },
  DE: {
    MAX_AMOUNT: 20000,
    MIN_AMOUNT: 1,
    currency: 'EUR',
  },
  GB: {
    MAX_AMOUNT: 25000,
    MIN_AMOUNT: 1,
    currency: 'GBP',
  },
  US: {
    MAX_AMOUNT: 20000,
    MIN_AMOUNT: 1,
    currency: 'USD',
  },
}
export const CROWDFUNDING_CAMPAIGN_MAX_DAYS = 30
export const MONEY_POOLS_MAX_DAYS = CROWDFUNDING_CAMPAIGN_MAX_DAYS

export const COVER_IMAGE_UPLOAD_ERRORS = {
  FILE_INVALID_TYPE: 'file-invalid-type',
  FILE_TOO_LARGE: 'file-too-large',
  FILE_TOO_SMALL: 'file-too-small',
  TOO_MANY_FILES: 'too-many-files',
}

export const CONTRIBUTIONS_PAGE_SIZE = {
  mobile: 5,
  desktop: 10,
}

export const WALLET_SETTINGS_SERV_FAIL = 'WALLET_SETTINGS_SERV_FAIL'

export const MIN_CONTRIBUTOR_ROW_HEIGHT = '1.6em'

export const MIN_ACTIVITY_ROW_HEIGHT = '1.1em'

export const USR_TXNS_COOKIE_EXPIRY = 15 * 60 * 1000

export const UNDER_REVIEW_ERROR = 'UNDER_REVIEW'

export const INVALID_IMAGE = 'INVALID_IMAGE'

export const STORAGE_EXPIRATION = 1000 * 60 * 30 // 30 mins

export const FUNDING_SOURCES = {
  HOLDING: 'HOLDING',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
}

export const CFS_INTENT = 'MONEYPOOLS'
export const CFS_ELIGIBILITY_URL = '/myaccount/bundle/product-eligibility'
export const BRAZIL_ELIGIBILITY_URL = '/policy/hub/cip'

export const TRANSACTION_DETAILS_URL = '/myaccount/transactions/details/'

export const CIP_FLOW_URL = {
  HOMEINFO_URL: '/myaccount/info/flow/educate',
  RETURN_URL: '/myaccount/summary',
  ENTRY_POINT: 'POOLS',
}

export const AUTH_STATES = {
  LOGGEDIN: 'LOGGEDIN',
  IDENTIFIED: 'IDENTIFIED',
}

export const ACCOUNT_TYPES = {
  PERSONAL: 'PERSONAL',
  PREMIER: 'PREMIER',
  BUSINESS: 'BUSINESS',
}

export const SUBSCRIPTION_TYPES = {
  WALLET: 'WALLET',
  CASH: 'CASH',
  CASH_PLUS: 'CASH_PLUS',
}
export const FEATURES_TYPES = {
  CROSS_BORDER: 'SEND_MONEY_CROSS_BORDER_FRIENDS_AND_FAMILY',
  DOMESTIC: 'SEND_MONEY_DOMESTIC_FRIENDS_AND_FAMILY',
}
export const FLOW_DETAILS = {
  FEATURE: 'PERSONAL',
  SUB_FLOW: 'CONTRIBUTE',
}

export const EXPERIMENTS = {
  // all experiments created with Elmo, unless otherwise stated
  MONEY_POOLS_MAIN: {
    TREATMENT: 'money_pools_main_treatment',
    CONTROL: 'money_pools_main_control',
  },
  P2P_GUEST_FF: {
    TREATMENT: 'p2p_guest_friends_and_family_treatment',
    CONTROL: 'p2p_guest_friends_and_family_control',
  },
  CFPB: {
    // NOTE: these are from PXP
    TREATMENT: 'cfpb_paypal_cash_us_treatment',
    CONTROL: 'cfpb_paypal_cash_us_control',
  },
  MONEY_POOLS_CROWDFUNDING: {
    TREATMENT: 'Trmt_money_pools_crowdfunding_1',
    CONTROL: 'Ctrl_money_pools_crowdfunding',
  },
  CROWD_FUNDING_GUEST_DONATION: {
    TREATMENT: 'Trmt_crowdfunding_guest_donation_1',
    CONTROL: 'Ctrl_crowdfunding_guest_donation',
  },
  AUCIP: {
    TREATMENT: 'PAYPALWALLET_FEATURES_RAMP_TRMT',
    CONTROL: 'PAYPALWALLET_FEATURES_RAMP_CTRL',
  },
  GENEROSITY_NETWORK_IMAGE_SCAN: {
    TREATMENT: 'Trmt_generosity_network_image_scan',
    CONTROL: 'Ctrl_generosity_network_image_scan',
  },
  GENEROSITY_NETWORK_DNW_INTEGRATION: {
    TREATMENT: 'Trmt_generosity_network_dnw_integration',
    CONTROL: 'Ctrl_generosity_network_dnw_integration',
  },
  GENEROSITY_NETWORK_FOR_CHARITY: {
    TREATMENT: 'Trmt_Generosity_Network_For_Charity',
    CONTROL: 'Ctrl_Generosity_Network_For_Charity',
  },
}

// We use an experiment to check whether the guest user can do guest F&F
// and we'll check this list of countries to see if the pool owner can receive
// guest contributions. Elmo was not allowing us to spoof the security context in
// prod.
export const guestEnabledCountries = [
  'US',
  'AT',
  'BE',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'NL',
  'NO',
  'PL',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
]

/* ------------- */

export const ELMO_RESOURCE_NAME = [
  'main:walletweb:transfer',
  'main:paypalwallet:feature',
].join(',')
export const ELMO_CROWDFUNDING_RESOURCE_NAME = 'main:crowdfunding:pool'

export const ELMO_GN_IMAGE_SCAN = 'main:generosity:network:image_scan'

export const ELMO_GN_DNW_INTEGRATION = 'main:generosity:network:dnw_integration'

export const ELMO_GN_CHARITY = 'main:generosity:network:charity'

export const PXP_PAGE_NAME = 'cfpb_paypal_cash_us'

export const POOLS_CAMPAIGN_TYPES = {
  PUBLIC_MONEY_POOL: 'PUBLIC_MONEY_POOL',
  CROWD_FUNDING: 'CROWD_FUNDING',
}
export const CHARITY = 'charity'

export const CROWD_FUNDING_HOME_URI = '/generosity-network'
export const CIP_ELIGIBILITY_CODES = {
  USER_REACHED_CAMPAIGN_CREATION_LIMIT: 'USER_REACHED_CAMPAIGN_CREATION_LIMIT',
  RUGS_CHECK_HIT_WITH_DC_NEED_MORE_DATA: 'NEED_MORE_DATA',
  RUGS_CHECK_HIT_WITH_DC_MANUAL_REVIEW: 'MANUAL_REVIEW',
  RUGS_CHECK_HIT_WITH_DC_PENDING_VERIFICATION: 'PENDING_VERIFICATION',
  RUGS_CHECK_HIT_WITH_DC_PENDING: 'PENDING',
  RUGS_CHECK_HIT_FAILED: 'RUGS_CHECK_HIT_FAILED',
  RUGS_CHECK_FAILED: 'RUGS_CHECK_FAILED',
}

export const GENEROSITY_NETWORK_FLOWS = {
  GENEROSITY_NETWORK_FUNDRAISER_CHARITY:
    'GENEROSITY_NETWORK_FUNDRAISER_CHARITY',
  GENEROSITY_NETWORK_FUNDRAISER: 'GENEROSITY_NETWORK_FUNDRAISER',
}

export const NO_DESCRIPTION_ERRORS = ['REJECTED']

export const DEXTER_SPECIFIC_ERRORS = [
  'REJECTED',
  'AUTO_VERIFICATION_FAILED',
  'NOT_APPLICABLE',
  'SERVICE_UNAVAILABLE',
  'INVALID_REQUEST',
]

export const CIP_ERROR_CODE = [
  'REJECTED',
  'SERVICE_UNAVAILABLE',
  'MANUAL_REVIEW',
  'AUTO_VERIFICATION_FAILED',
  'NOT_APPLICABLE',
]

export const ELIGIBILITY_STATUS = {
  INELIGIBLE: 'INELIGIBLE',
  ELIGIBLE: 'ELIGIBLE',
  UNKNOWN: 'UNKNOWN',
}

export const MIN_TRANSFER_AMOUNT = 0

export const VERIFICATION_FLOW = {
  RUGS: 'RUGS',
  DEXTER: 'DEXTER',
}

export const PRODUCT_TYPES = {
  GENEROSITY_NETWORK: 'GENEROSITY_NETWORK',
  GENEROSITY_NETWORK_CHARITIES: 'GENEROSITY_NETWORK_CHARITIES',
}

const DIRECT = 'DIRECT'
const PPGF = 'PPGF'

export const INTEGRATION_IDENTIFIER = {
  DIRECT,
  PPGF,
}
export const DIRECT_MODEL_ENROLLED = 'DIRECT_MODEL_ENROLLED'
export const PPGF_ENROLLED = 'PPGF_ENROLLED'
export const PPGF_UNENROLLED = 'PPGF_UNENROLLED'

export const CHARITY_TYPES = {
  DIRECT_MODEL_ENROLLED: DIRECT_MODEL_ENROLLED,
  PPGF_ENROLLED: PPGF_ENROLLED,
  PPGF_UNENROLLED: PPGF_UNENROLLED,
}

export const PAYMENTS_TOKEN_DEFAULT_AMOUNT = '0'

export const INTEGRATION_IDENTIFIER_BY_COUNTRY = {
  AU: {
    CHARITY_TYPE: PPGF_ENROLLED,
    INTEGRATION_IDENTIFIER: PPGF,
  },
  CA: {
    CHARITY_TYPE: PPGF_ENROLLED,
    INTEGRATION_IDENTIFIER: PPGF,
  },
  DE: {
    CHARITY_TYPE: DIRECT_MODEL_ENROLLED,
    INTEGRATION_IDENTIFIER: DIRECT,
  },
  GB: {
    CHARITY_TYPE: PPGF_ENROLLED,
    INTEGRATION_IDENTIFIER: PPGF,
  },
  US: {
    CHARITY_TYPE: PPGF_ENROLLED,
    INTEGRATION_IDENTIFIER: PPGF,
  },
}

export const GN_DISCLAIMERS = {
  AU: {
    consumerLink: 'https://www.paypal.com/au/webapps/mpp/paypal-fees',
    merchantLink: 'https://www.paypal.com/au/webapps/mpp/merchant-fees',
    termsAndConditions:
      'https://www.paypal.com/AU/webapps/mpp/ua/generositynetwork-tnc?locale.x=en_AU',
    userAgreement:
      'https://www.paypal.com/au/webapps/mpp/ua/useragreement-full',
  },
  CA: {
    consumerLink: 'http://paypal.com/ca/webapps/mpp/paypal-fees',
    merchantLink: 'https://www.paypal.com/ca/webapps/mpp/merchant-fees',
    termsAndConditions:
      'https://www.paypal.com/CA/webapps/mpp/ua/generositynetwork-tnc?locale.x=en_CA',
    userAgreement:
      'https://www.paypal.com/ca/webapps/mpp/ua/useragreement-full',
  },
  DE: {
    consumerLink: 'https://www.paypal.com/de/webapps/mpp/paypal-fees',
    merchantLink: 'https://www.paypal.com/de/webapps/mpp/merchant-fees',
    termsAndConditions:
      'https://www.paypal.com/DE/webapps/mpp/ua/generositynetwork-tnc?locale.x=en_DE',
    userAgreement:
      'https://www.paypal.com/de/webapps/mpp/ua/useragreement-full',
  },
  GB: {
    consumerLink: 'https://www.paypal.com/uk/webapps/mpp/paypal-fees',
    merchantLink: 'https://www.paypal.com/uk/webapps/mpp/merchant-fees',
    termsAndConditions:
      'https://www.paypal.com/UK/webapps/mpp/ua/generositynetwork-tnc?locale.x=en_UK',
    userAgreement:
      'https://www.paypal.com/uk/webapps/mpp/ua/useragreement-full',
  },
  US: {
    consumerLink: 'https://www.paypal.com/us/webapps/mpp/paypal-fees',
    merchantLink: 'https://www.paypal.com/us/webapps/mpp/merchant-fees',
    termsAndConditions:
      'https://www.paypal.com/US/webapps/mpp/ua/generositynetwork-tnc?locale.x=en_US',
    userAgreement:
      'https://www.paypal.com/us/webapps/mpp/ua/useragreement-full',
  },
}

export const COUNTRY_NOT_SUPPORTED = 'country_not_supported'

export const CROWD_FUNDING = 'CROWD_FUNDING'

export const GNC_DISCLAIMERS = {
  AU: {
    reassigningConditionsUrl:
      'https://www.paypal.com/au/webapps/mpp/givingfund/policies/donation-delivery',
  },
  CA: {
    reassigningConditionsUrl:
      'https://www.paypal.com/ca/webapps/mpp/givingfund/policies/donation-delivery-policy',
  },
  GB: {
    reassigningConditionsUrl:
      'https://www.paypal.com/uk/webapps/mpp/givingfund/policies#DonationDeliveryPolicy',
  },
  US: {
    termsUrl:
      'https://www.paypal.com/webapps/mpp/givingfund/policies/donor-terms-of-service',
    failToDonateUrl:
      'https://www.paypal.com/us/webapps/mpp/givingfund/policies/donation-delivery-policy',
    timeframeUrl:
      'https://www.paypal.com/us/webapps/mpp/givingfund/policies/donation-delivery-policy',
  },
}

export const INSTRUMENT_EVENTS = {
  DW_GIVING: 'dw_giving',
  DW_GIVING_DETAIL_DONATE_PRESSED: 'dw_giving_detail_donate_pressed',
  DW_GIVING_MANAGE_FUNDRASIER_DONATE_PRESSED:
    'dw_giving_manage_fundraiser_donate_pressed',
}

export const INSTRUMENT_TAGS = {
  CL: 'cl',
  DONATE: 'donate',
  WEB: 'web',
}

export const KEY_PRESS_EVENTS = {
  ENTER_KEY: 'Enter',
}

export const TOAST_NOTIFICATIONS = {
  EDIT_SUCCESS: 'edit_success',
  COPY_SUCCESS: 'copy_success',
}

export const SCREEN_NAME_MAPPING = {
  types: 'start_fundraiser',
  basics: 'create_fundraiser',
  story: 'tell_story',
  cover: 'add_photo',
  publish: 'publish',
}
/* ------------- */

export const QUALTRICS_GN_CREATION_FEEDBACKLINK =
  'poolsnodeweb-generosityNetwork-creation-feedbacklink-aug2021'
export const QUALTRICS_GNC_CREATION_FEEDBACKLINK =
  'poolsnodeweb-generosityNetworkForCharity-creation-feedbacklink-aug2021'

/**------PATHS------------- */
export const PATHS = {
  CREATE_CROWDFUNDING: 'create-crowdfunding',
}
